import styled from "styled-components";

const LayoutLimit = styled.div`
  min-width: 1000px;
  display: flex;
  min-height: 100vh;
`;

// const Content = styled.main`
//   flex: 1;
//   width: 100%;
//   max-width: 1200px;
//   padding: 20px;
// `;

export { LayoutLimit };
